<template>
  <div :is="tag" :class="[baseClass, modifierClasses]">
    <div v-if="$slots.content">
      <!-- @slot Use for the section header's content; typically `<heading>` and `<subheading>` components. -->
      <slot name="content"></slot>
    </div>
    <div v-if="$slots.actions">
      <!-- @slot Use for the section header's actions/supplemental content. -->
      <slot name="actions"></slot>
    </div>
    <!-- @slot Slot for content. -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PdlSectionHeader',
  props: {
    /**
     * `isDividing` sets a bottom border to the section header container.
     */
    isDividing: {
      type: Boolean,
      default: false,
    },
    /**
     * `isNonStacking` does not stack on small viewports.
     */
    isNonStacking: {
      type: Boolean,
      default: false,
    },
    /**
     * Size of section header (`xxl`, `xl`,`lg`, `md`, & `sm`), which determines heading and subheading font sizes.
     */
    size: {
      type: String,
      default: '',
    },
    /**
     * Set the container element type.
     */
    tag: {
      type: String,
      default: 'div',
    },
  },
  data() {
    return {
      baseClass: 'pdl-section-header',
    };
  },
  computed: {
    modifiers() {
      let variants = [this.size];
      if (this.isDividing) {
        variants.push('dividing');
      }
      if (this.isNonStacking) {
        variants.push('non-stacking');
      }
      return variants;
    },
    modifierClasses() {
      return this.modifiers.map((variant) => `${this.baseClass}--${variant}`).join(' ');
    },
  },
};
</script>
<style lang="scss">
@import 'SectionHeader.scss';
</style>
